import * as React from "react";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

const HelpTutorials = () => {
    logUI("MBHWeb.UI.HelpTutorials.ComponentDidMount", new Date(), Tools.getURLPath());
    return (
        <div className="container-fluid body-content">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <h1>Help and Tutorials</h1>
                </div>
            </div>
        </div>
    );
};

export default HelpTutorials;
